import { create } from 'zustand';
const useStoredMediaOutput = create(() => ({
    images: [],
}));
const reactiveOutput = {
    useImages: () => {
        return useStoredMediaOutput((s) => s.images);
    },
};
export class StoredMediaServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    getImages() {
        return useStoredMediaOutput.getState().images;
    }
    addImage(image) {
        useStoredMediaOutput.setState((s) => ({
            images: [...s.images, image],
        }));
    }
    removeImage(id) {
        useStoredMediaOutput.setState((s) => ({
            images: s.images.filter((i) => i.id !== id),
        }));
    }
    setImages(images) {
        useStoredMediaOutput.setState({ images });
    }
}
